import { render, staticRenderFns } from "./pattern-field-suggestions-wrapper.vue?vue&type=template&id=e447c746&"
import script from "./pattern-field-suggestions-wrapper.vue?vue&type=script&lang=js&"
export * from "./pattern-field-suggestions-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./pattern-field-suggestions-wrapper.vue?vue&type=style&index=0&id=e447c746&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports